import { JwtHighbondClient } from '@acl-services/jwt-highbond-client';
import { useAppConfig } from './app-config';

const createJwtHighbondClient = (options: {
  tokenRefreshUrl: string;
  loginUrl: string;
}) =>
  new JwtHighbondClient({
    ...options,
    autoRedirect: true,
  });

export const useJwtHighbondClient = () => {
  const appConfig = useAppConfig();

  const client = createJwtHighbondClient({
    tokenRefreshUrl: appConfig.tokenRefreshUrl,
    loginUrl: appConfig.loginUrl,
  });

  return client;
};
